import React, {PureComponent} from 'react';
import {Button} from '..';

import RotateCwSVG from 'assets/icons/rotate-cw.svg';
import intl from 'react-intl-universal';
import RotateCcwSVG from 'assets/icons/rotate-ccw.svg';

import styles from './styles';

export default class RotateSubMenu extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      rotation: props.cropper.rotation
    };
  }

  onSelect = (direction) => () => {
    let {rotation} = this.state;
    const {cropper} = this.props;

    if (direction === 'cw') {
      rotation += 90;
    } else if (direction === 'ccw') {
      rotation -= 90;
    }

    cropper.rotate(rotation);

    this.setState({
      rotation
    });
  };

  render() {
    return (
      <div className={styles.subMenuContainer}>
        <Button
          className={`${styles.subMenuSubsection} ${styles.subMenuOption}`}
          onClick={this.onSelect('cw')}
        >
          <RotateCwSVG className={styles.inlineIcon} />
          {intl.get('Rotate 90 CW')}
        </Button>
        <Button
          className={`${styles.subMenuSubsection} ${styles.subMenuOption}`}
          onClick={this.onSelect('ccw')}
        >
          <RotateCcwSVG className={styles.inlineIcon} />
          {intl.get('Rotate 90 CCW')}
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdjustmentMenu/RotateSubMenu.jsx